import { combineReducers } from 'redux';

import { SET_CURRENT_OUTLET, SET_OUTLETS } from '../actions/outlet/constants';
import createReducer from '../utils/createReducer';

const currentOutlet = createReducer([], {
  [SET_CURRENT_OUTLET]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.data.data,
});

const outlets = createReducer([], {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [SET_OUTLETS]: (draft, { payload }) => payload.outlets,
});

export default combineReducers({
  currentOutlet,
  outlets,
});
